// What the page tells the top bar to show: a title and, on a sub-page, a back arrow.
//
// Pages used to draw their own second bar under the app header ("Partner Details" with a Back
// link), which cost 66px of every sub-page on top of the 67px header. Now the page only registers
// its title and back action here (through CommonPageNavigation, which renders nothing itself) and
// the header shows them, so the content gets the whole screen. A page without a registration
// gets the plain header.
//
// A registration is never cleared when its page unmounts: the next page registers a frame or two
// after the old one is gone, and clearing in between flashed the hamburger and an empty title. The old
// header stays until the next page overwrites it, or until the navigation has finished without one.
export type PageHeader = {
  // The route path the registering page was mounted for. plugins/pageHeader.client.ts uses it to drop a
  // registration that no page of the new route replaced.
  path: string,
  title: string,
  showBack: boolean,
  goBack: () => void,
  // Where the back arrow leads, shown next to it ("Agenda"); none for a page with a back of its own.
  backLabel?: string | null,
  // A page the back arrow of a page opened from it can lead up to (see useUpNavigation). Default: no back arrow of its
  // own, i.e. a top-level page.
  list?: boolean,
};

export const usePageHeader = () => useState<PageHeader | null>('wad4-page-header', () => null);
